import { deepMix } from '@antv/util';
import { Light } from './light';
/**
 * Default theme.
 */
export const Classic = (options) => {
    return deepMix({}, Light(), {
        category10: 'category10',
        category20: 'category20',
    }, options);
};
Classic.props = {};
//# sourceMappingURL=classic.js.map